<template>
  <div class="NewsDetail">
    <section-header
      heading="2"
      ja="「ポケピース meets romakyun」イベント開始！"
    />
    <div data-v-1ae908a8="">
      <div data-v-1ae908a8="" class="text-area">
        24.03.06<br /><br />
        ポケピースの仲間たちがromakyunに登場！<br /><br />
        ポケピースデザインのスタンプやシールが楽しめます。<br /><br />
        <center>
          <img
            src="@/assets/Png/News/PokePeace/pokepeace_01.png"
            style="max-width: 100%;"
          />
        </center>
        <br /><br />■実施期間<br />2024年3月6日(水) ～ 3月31日(日)<br /><br />■対象機種<br />全国の「romakyun（ろまきゅん）」<br /><br />
        <center>
          <img
            src="@/assets/Png/News/PokePeace/Kyoutai_romakyun.png"
            style="max-width: 85%;"
          />
        </center>
        <br /><br />
        <center>
          <a href="https://puri.sega.jp/location-map/?id=romakyun"
            >romakyunが遊べるお店はこちら</a
          >
        </center>
        <br /><br />■内容<br />スタンプ全32種、シールデザイン1種<br /><br />
        <center>
          <img
            src="@/assets/Png/News/PokePeace/pokepeace_02.png"
            style="max-width: 100%;"
          />
        </center>
        <br>
        ポケピースデザインの
        <br>
        <a href="https://puri.sega.jp/location-map/?id=romakyun">romakyunが遊べるお店はこちら</a>
        <br>
        <br>
        さらに！全国20店舗限定で、ポケピースデザインのromakyunも登場！
        <br>
        <br>
        <center>
          <img
            src="@/assets/Png/News/PokePeace/pokepeace_03.png"
            style="max-width: 100%;"
          />
        </center>
        <br /><br />※遊べる内容は通常デザインのromakyunと同じです。<br /><br />シールが出てきたら、<br />連動アプリ「プリクラON」で<br />プリデータのダウンロードも忘れずに♪<br /><br />ダウンロードすると、<br />3秒動画「モーメント」も見れるよ！<br />SNSにもアップしてね♪<br /><br />プリクラONのカメラで<br />撮影したシールを見ると<br />シールが動く「ARプリクラ」も<br />楽しめるから試してみてね♪<br /><br />■「ポケピース」とは<br />世界のどこかにある、ちいさなまち。<br />ポケモンとにんげんたちが集まる、シェアハウスがありました。<br />ここでのくらしは、のんびりきまま、自由な毎日。<br />みんなでおひるねしたり、特別な日にはパーティーをしたり。<br />ポケモンたちの、“ピース”なくらし。<br />ちょっとのぞいてみませんか。<br /><br />セガ公式SNSでも最新情報を発信中！<br /><br />
        <a href="https://www.instagram.com/sega_purikura/">
          <img src="@/assets/Png/News/PokePeace/Linkicon_01_IG.jpg" style="max-width: 70%;"/>
        </a>
        <a href="https://twitter.com/SEGA_purikura/">
          <img src="@/assets/Png/News/PokePeace/Linkicon_02_TW.jpg" style="max-width: 50%;"/>
        </a>
        <a href="https://lin.ee/BncFzGc">
          <img src="@/assets/Png/News/PokePeace/Linkicon_03_LINE.jpg" style="max-width: 50%;"/>
        </a>
        <a href="https://www.tiktok.com/@sega_purikura">
          <img src="@/assets/Png/News/PokePeace/Linkicon_04_TT.jpg" style="max-width: 50%;"/>
        </a>
        <br /><br />ⓒSEGA<br />©Pokémon. ©Nintendo/Creatures Inc./GAME FREAK
        inc.
      </div>
      <sub-btn @click="onNewsList()">みんなへのお知らせ一覧に戻る</sub-btn>
      <sub-btn @click="onHome()">ホームに戻る</sub-btn>
    </div>
  </div>
</template>

<script>
import Protobuf from "../mixins/protobuf";
import SectionHeader from "../components/SectionHeader";
import SubBtn from "../components/SubBtn.vue";

export default {
  name: "NewsDetail",
  components: { SectionHeader, SubBtn },
  mixins: [Protobuf],
  data() {
    return {
      title: "",
      img: "",
      description: "",
    };
  },
  methods: {
    onNewsList() {
      this.$router.push("/newsList");
    },
    onHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.NewsDetail {
  .text-area {
    margin: 30px 30px 0;
    font-size: 12px;
    color: #373737;

    img {
      max-width: 100%;
    }

    p {
      margin-top: 1em;
    }

    .linkArea {
      .twitter {
        margin: 0 5px;
      }
    }

    .centerBlock {
      display: flex;
      justify-content: center;

      & > a:not(:last-of-type) {
        margin-right: 30px;
      }

      & > a:last-of-type {
        margin-left: 18px;
      }
    }
  }
}
</style>
